var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_178_39636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9 16.776C20.4965 14.6424 21.2255 11.9832 20.9403 9.33375C20.6551 6.68427 19.3767 4.24121 17.3627 2.49634C15.3486 0.751469 12.7483 -0.165652 10.0852 -0.0704088C7.42209 0.0248339 4.89395 1.12537 3.00966 3.00966C1.12537 4.89395 0.0248339 7.42209 -0.0704088 10.0852C-0.165652 12.7483 0.751469 15.3486 2.49634 17.3627C4.24121 19.3767 6.68427 20.6551 9.33375 20.9403C11.9832 21.2255 14.6424 20.4965 16.776 18.9L21.876 24L24 21.88L18.9 16.776ZM10.5 18C9.01664 18 7.56659 17.5601 6.33322 16.736C5.09985 15.9119 4.13856 14.7406 3.5709 13.3701C3.00324 11.9997 2.85472 10.4917 3.14411 9.03682C3.4335 7.58196 4.1478 6.24559 5.19669 5.19669C6.24559 4.1478 7.58196 3.4335 9.03682 3.14411C10.4917 2.85472 11.9997 3.00324 13.3701 3.5709C14.7406 4.13856 15.9119 5.09985 16.736 6.33322C17.5601 7.56659 18 9.01664 18 10.5C17.9981 12.4886 17.2074 14.3951 15.8013 15.8013C14.3951 17.2074 12.4886 17.9981 10.5 18Z",
    fill: "#22232C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_178_39636"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.92d8dfea56a6460e26775cdf86811633.svg";
export { ForwardRef as ReactComponent };